import { toast } from "react-toastify";

import { nextCargoApi } from "../../baseApi";
import { ipifyApi } from "../../ipify";
import { CallDriver, CheckInCalled, CheckinsByCompany, CheckinsCompanyActives, SaveCheckin, SaveCheckinCheckout } from "./checkins.types";
import { groupCheckinsByDays } from "./checkins.utils";

export const checkinsApi = nextCargoApi.injectEndpoints({
  endpoints: (build) => ({
    getCheckinsCompanyActivesByCompany: build.query<CheckinsByCompany["result"], CheckinsByCompany["args"], CheckinsCompanyActives[]>({
      query: ({ id }) => `/checkins/company/actives/${id}`,
      transformResponse: (response, meta, arg) => groupCheckinsByDays({ response, arg })
    }),
    getCheckinsCalledByCompany: build.query<CheckInCalled[], Pick<CheckInCalled, "id">>({
      query: ({ id }) => `/checkins/called/${id}`
    }),
    callDriver: build.mutation<CallDriver["result"], CallDriver["args"]>({
      query: (body) => ({
        url: "/checkins/setcall",
        method: "POST",
        body
      })
    }),
    saveCheckin: build.mutation<SaveCheckin["result"], SaveCheckin["args"]>({
      query: (body) => ({
        url: "/checkins/save",
        method: "POST",
        body
      }),
      onQueryStarted: (args, { queryFulfilled }) => {
        const { status } = args;

        try {
          ipifyApi.util.invalidateTags(["IP"]);
        } catch {
          //Do nothing
        }

        toast.promise(queryFulfilled, {
          pending: status ? "Realizando Checkin..." : "Resetando checkin...",
          success: status ? "Checkin Realizado com sucesso!" : "Reset do checkin realizado com sucesso!",
          error: status ? "Erro ao realizar Checkin!" : "Erro ao efetuar reset do checkin!"
        });
      }
    }),
    saveCheckinCheckout: build.mutation<SaveCheckinCheckout["result"], SaveCheckinCheckout["args"]>({
      query: (body) => ({
        url: "/checkins/checkout",
        method: "POST",
        body
      })
    }),
    saveCheckinRoot: build.mutation<SaveCheckin["result"], SaveCheckin["args"]>({
      query: (body) => ({
        url: "/checkin",
        method: "POST",
        body
      })
    })
  })
});

checkinsApi.enhanceEndpoints({
  addTagTypes: ["Checkins", "CheckinCalled", "CheckinsActive", "CheckinCall"],
  endpoints: {
    getCheckinsCompanyActivesByCompany: {
      providesTags: (result, err, { id }) => [{ type: "CheckinsActive", id }]
    },
    getCheckinsCalledByCompany: {
      providesTags: (result) =>
        result ? [...result.map(({ id }) => ({ type: "CheckinCalled" as const, id })), { type: "CheckinCalled", id: "LIST" }] : [{ type: "CheckinCalled", id: "LIST" }]
    },
    callDriver: {
      invalidatesTags: (result, err, { id }) => [{ type: "CheckinCall", id }]
    },
    saveCheckin: {
      invalidatesTags: [
        "SyncExpedition",
        "Checkins",
        "SettingsByCompany",
        "Queue",
        "Attendances",
        "QueueByCompany",
        "Settings",
        "CheckinsActive",
        "Queues",
        "QueueNextDateByCompany",
        "DriverPosition",
        "QueueDelayStatus",
        "Popup"
      ]
    },
    saveCheckinRoot: {
      invalidatesTags: ["Checkins"]
    },
    saveCheckinCheckout: {
      invalidatesTags: ["SyncExpedition", "Checkins"]
    }
  }
});
